import React from 'react';
import styled from 'styled-components';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores';
import {LabelForm } from '../componentes_generales/componentes_formulario/labels';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { InputText }  from '../componentes_generales/componentes_formulario/inputs/inputtext';
import global_axios from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;
class FormInven11 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {  
      pedidoSeleccionado:'', 
      motivo_pedido:'',
      estadosPedido:[],
      historicosPedido:[],
      motivosPedidos:[],
      pedido:'',
      cliente:'',
      observacion:'',
      columnDefs: [ {   header: "Nro.",
                        field: "NroItem",
                        width: 40,
                        type: "string",
                        suppressSorting: true,
                        suppressFilter: true
                    },
                    {   header: "Pedido",
                        field: "Pedido",
                        width: 105,
                        type: "string"
                    },
                    {   header: "Cliente",
                        field: "Cliente",
                        width: 350,
                        type: "string"
                    }, 
                    {   header: "Fecha Control",
                        field: "Fecha",
                        width: 105,
                        type: "string"
                    },                 
                    {   header: "Motivo",
                        field: "Estado_pedido",
                        width: 200,
                        type: "string",
                        suppressSorting: true,
                        suppressFilter: true
                    },                                        
                    {   header: "Comentario",
                        field: "Observacion",
                        width: 250,
                        type: "string",
                        suppressSorting: true,
                        suppressFilter: true
                    },                    
                  ],
          columnHistorico: [{header: "Nro.",
                          field: "NroItem",
                          width: 40,
                          type: "string",
                          suppressSorting: true,
                          suppressFilter: true
                      },
                      {   
                      header: "Fecha",
                      field: "Fecha",
                      width: 100,
                      type: "string",
                      suppressSorting: true,
                      suppressFilter: true
                    },
                    {   header: "Motivo Retraso",
                        field: "Motivo_retraso",
                        width: 150,
                        type: "string"
                    },
                    {   header: "Observacion",
                        field: "Observacion",
                        width: 350,
                        type: "string"
                    }       
                  ],          
        pagination: {
          totalFilas: 0,
          totalFilasPorPagina: 0,
          primaraFilaPagina: 0,
          ultimaFilaPagina: 0,
      }, 
      paginationHistorico: {
        totalFilas: 0,
        totalFilasPorPagina: 0,
        primaraFilaPagina: 0,
        ultimaFilaPagina: 0,
      },      
    };

    this.gridOptions = {
        enableColResize: true,
        enableSorting: true,
        enableFilter: true,
        rowSelection: "single",
        suppressScrollOnNewData: true,
        paginationAutoPageSize:true,
        pagination: true,
        suppressPaginationPanel: true,
      onRowDoubleClicked: event => {
        let pedido = event.data;
        //this.getAsientoById(movimiento);
        this.cargarPedidoModificar(pedido) 
      },
      onPaginationChanged: () => {
        if(!this.api){
            return;
        }
        let totalFilas = this.api.paginationGetRowCount();
        let totalFilasPorPagina = this.api.paginationGetPageSize();
        let ultimaFilaPagina = (totalFilasPorPagina * (this.api.paginationGetCurrentPage()+1));
        let indexPage = this.api.paginationGetCurrentPage();

        if( ultimaFilaPagina >  totalFilas){
            ultimaFilaPagina = totalFilas;
        }
   
        let pagination = {
            totalFilas: totalFilas,
            totalFilasPorPagina: totalFilasPorPagina,
            primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
            ultimaFilaPagina: ultimaFilaPagina
        };
       
        this.setState({pagination});
      },
    };
    this.gridOptionsHistorico = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: "single",
      suppressScrollOnNewData: true,
      paginationAutoPageSize:true,
      pagination: true,
      suppressPaginationPanel: true,
    onRowDoubleClicked: event => {
      // let pedido = event.data;
      // //this.getAsientoById(movimiento);
      // this.cargarPedidoModificar(pedido) 
    },
    onPaginationChanged: () => {
      if(!this.apiHistorico){
          return;
      }
      let totalFilas = this.apiHistorico.paginationGetRowCount();
      let totalFilasPorPagina = this.apiHistorico.paginationGetPageSize();
      let ultimaFilaPagina = (totalFilasPorPagina * (this.apiHistorico.paginationGetCurrentPage()+1));
      let indexPage = this.apiHistorico.paginationGetCurrentPage();

      if( ultimaFilaPagina >  totalFilas){
          ultimaFilaPagina = totalFilas;
      }
 
      let paginationHistorico= {
        totalFilas: totalFilas,
        totalFilasPorPagina: totalFilasPorPagina,
        primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
        ultimaFilaPagina: ultimaFilaPagina
    };
      this.setState({paginationHistorico});
    },
  };

    this.onGridReady = this.onGridReady.bind(this);   
    this.onGridReadyHistorico = this.onGridReadyHistorico.bind(this);   
    this.submit = this.submit.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.cargarPedidosIniciales=this.cargarPedidosIniciales.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.cargarPedidoModificar = this.cargarPedidoModificar.bind(this);
  }  
  cargarPedidoModificar(pedido){
    
    if(pedido!==null && pedido!==undefined){
        global_axios(
          {
            method: 'GET',
            url: '/retrasodespacho/historico_despacho/' + pedido.Pedido,
          }
        ).then((pedidos)=>{
           pedidos= pedidos.data;
           let historicosPedido=[];
            for(let i=0; i<pedidos.length;i++){
              let pedido={};
              pedido.NroItem= i+1;
              pedido.Fecha= pedidos[i].Fecha.split('T')[0];
              pedido.Observacion=pedidos[i].Observacion; 
              for(let j=0; j<this.state.motivosPedidos.length;j++){
                if(this.state.motivosPedidos[j].value.trim()===pedidos[i].MotivoRetraso.trim())
                {
                  pedido.Motivo_retraso=this.state.motivosPedidos[j].label;
                  break;
                }
              }
              historicosPedido.push(pedido) 
            }

            this.setState({ historicosPedido,pedidoSeleccionado:pedido.Pedido,pedido:pedido.Pedido, cliente:pedido.Cliente, motivo_pedido:pedido.valueEstadoPedido, observacion:pedido.Observacion})
        })
        .catch((err)=>{
            alert('No se cargar el historico de despacho...');
        });
        
       
    }
  }

  submit(e){
    e.preventDefault();
    if(this.state.motivo_pedido!==null && this.state.motivo_pedido!==undefined && this.state.motivo_pedido!==''){
      var sendData= {};
      sendData.pedido=this.state.pedido;
      sendData.motivo_pedido= this.state.motivo_pedido;
      sendData.observacion= this.state.observacion;
      global_axios(
        { method: 'POST',
          url: '/retrasodespacho/',
          data: sendData
        }
      )
      .then((response)=>{
        let respuesta= response.data;
        this.limpiar();
        this.cargarPedidosIniciales();
       
        alert('Se creo el retraso de despacho No: '+respuesta)
      })
      .catch((err)=>{
          alert('No se pudo procesar la transacción...');
      });
    }else{
      alert('Por favor ingrese un estado pedido')
    }
  }
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }
  onGridReadyHistorico(params) {
    this.apiHistorico = params.api;
    this.columnApiHistorico = params.columnApi;
  }
  cargarMotivos(ruta){
      global_axios.get(ruta)
      .then((response)=>{
       let motivosNuevos=[];
        for(let i=0; i < response.data.length; i++){
            let motivo={};
            motivo.value=response.data[i].value;
            motivo.label= response.data[i].label+" ("+response.data[i].value+")"
            motivosNuevos.push(motivo)
        }
          this.setState({estadosPedido:motivosNuevos})
      })
      .catch((err)=>{
          alert('No existe movimiento a presentar...');
      });
  }
  cargarMotivos2(){
    return new Promise((resolve, reject) => {
      global_axios.get('/retrasodespacho/motivos_retraso')
    .then((response)=>{
          resolve(response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` })));
      })
      .catch((err)=>{
          reject('Error al cargar datos de catálogos desde API: ' + err);
      });
  });
  }
  componentDidMount() {
    Promise.all([
        getItemDatosSesion('usuario'),
        this.cargarMotivos2(),
        this.props.generar_LogAuditoriaIngresoForm('0211'), 
    ])
    .then(([usuario,motivosPedidos]) => {
      this.setState(
        {
          usuario,motivosPedidos
        })
      this.cargarPedidosIniciales()
     
       
    })
    .catch(err => {
      console.log(err);
    });        
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0211');
  } 
  limpiar(){
    this.setState({
      pedido: '',
      cliente: '',
      motivo_pedido:null,
      observacion:'',
      pedidoSeleccionado:'', 
      historicosPedido:[]
      
    });
  }

  immutablePush(array, newItem){
    return [ ...array, newItem ];  
  }
  cargarPedidosIniciales(){
    global_axios({
        method: 'GET',
        url: '/retrasodespacho/'
      })
      .then((response)=> {  
          let pedidos= response.data;
          let estadosPedido=[];
          for(let i = 0; i<pedidos.length; i++){
            let pedido={};
            let motivoReciente= pedidos[i].det_retraso_despacho.length-1;
            if(motivoReciente>=0){
              pedido.NroItem= i+1;
              pedido.Pedido= pedidos[i].Pedido;
              pedido.Cliente= pedidos[i].det_cliente.Nombre+" ( "+pedidos[i].Cliente+" )"
              pedido.Fecha= pedidos[i].det_retraso_despacho[motivoReciente].Fecha.split('T')[0]
              pedido.Observacion= pedidos[i].det_retraso_despacho[motivoReciente].Observacion 
              pedido.valueEstadoPedido=pedidos[i].det_retraso_despacho[motivoReciente].MotivoRetraso.trim();
            
              for(let j=0; j<this.state.motivosPedidos.length;j++){
                if(this.state.motivosPedidos[j].value.trim()===pedidos[i].det_retraso_despacho[motivoReciente].MotivoRetraso.trim())
                {
                  pedido.Estado_pedido=this.state.motivosPedidos[j].label;
                  break;
                }
              }
              //pedido.Estado_pedido= pedidos[i].det_retraso_despacho[motivoReciente].MotivoRetraso 
              estadosPedido.push(pedido)
            }else{
              pedido.NroItem= i+1;
              pedido.Pedido= pedidos[i].Pedido;
              pedido.Cliente= pedidos[i].det_cliente.Nombre+" ( "+pedidos[i].Cliente+" )"
              pedido.Fecha=''
              pedido.Observacion= ''
              pedido.Estado_pedido= ''
              pedido.valueEstadoPedido=null
              estadosPedido.push(pedido)
            }
            
          }
          this.setState({estadosPedido})

      })
      .catch((error) => {
        this.props.cambiar_VisualizacionLoading(false);
        if (error.response){
          alert(error.response.data.msg);         
        }else{
          alert(error.message);
        }
      });   
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render(){        
        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Retraso Despacho</TituloForm>
            </HeaderForm>
            <CuerpoForm>
            <Row>
                <Row>
                  <ContainerCol className='col-xs-12 col-sm-12' align="center">
                    <h4><strong>Despachos</strong></h4>
                  </ContainerCol>
                </Row>
                <div className='col-md-12'>   
                    <AgGridRender altura='200px' data={this.state.estadosPedido} columnas={this.state.columnDefs}
                    gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                </div>
                <div className="col-xs-12 col-sm-12">
                    <Row>
                        <ContainerCol className="col-xs-12 col-sm-12">
                            <PaginationLabels>
                                {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                            </PaginationLabels>
                            <PaginationButtons>
                                <div className="btn-group btn-group-xs" role="group">
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToFirstPage()}>
                                        <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToPreviousPage()}>
                                        <i className="fa fa-angle-left fa-fw"></i>Anterior
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToNextPage()}>
                                        Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToLastPage()}>
                                        Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                    </button>
                                </div>
                            </PaginationButtons>
                        </ContainerCol>
                    </Row>
                </div>
                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                  <h4><strong>Histórico Pedido :{this.state.pedidoSeleccionado}</strong></h4>
                </ContainerCol>
                <div className='col-md-12'>   
                    <AgGridRender altura='100px' data={this.state.historicosPedido} columnas={this.state.columnHistorico}
                    gridOptions={this.gridOptionsHistorico} onGridReady={this.onGridReadyHistorico}/>
                </div>
              </Row>
              <div className="col-xs-12 col-sm-12">
                    <Row>
                        <ContainerCol className="col-xs-12 col-sm-12">
                            <PaginationLabels>
                                {this.state.paginationHistorico.primaraFilaPagina} a {this.state.paginationHistorico.ultimaFilaPagina} de {this.state.paginationHistorico.totalFilas}
                            </PaginationLabels>
                            <PaginationButtons>
                                <div className="btn-group btn-group-xs" role="group">
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToFirstPage()}>
                                        <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToPreviousPage()}>
                                        <i className="fa fa-angle-left fa-fw"></i>Anterior
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToNextPage()}>
                                        Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.apiHistorico.paginationGoToLastPage()}>
                                        Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                    </button>
                                </div>
                            </PaginationButtons>
                        </ContainerCol>
                    </Row>
                </div>
              <Row>
                    <ContainerCol className='col-sm-1'>
                        <LabelForm>Pedido No.:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                    <InputText name='pedido' value={this.state.pedido} disabled={true} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                    </ContainerCol>      
                    <ContainerCol className='col-sm-1'>                    
                        <LabelForm>Cliente</LabelForm>
                    </ContainerCol> 
                    <ContainerCol className='col-sm-4'>
                      <InputText name='cliente' value={this.state.cliente} disabled={true} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                    </ContainerCol>
                    <ContainerCol className='col-sm-1'>
                        <LabelForm>Estado Pedido:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-3'>
                        <ReactSelect options={ this.state.motivosPedidos }  value={this.state.motivo_pedido} func_onChange={(value)=>{this.setState({motivo_pedido: value})}}/>
                    </ContainerCol>               
              </Row>
              <Row margen_arriba={10}>
              <ContainerCol className='col-sm-1'>
                        <LabelForm>Observación:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-11'>
                    <InputText name='observacion' value={this.state.observacion} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                    </ContainerCol>        
              </Row>
             
                <form onSubmit={this.submit.bind(this)}>
                  {/* <Row margen_arriba={5}>
                    <div className='col-md-12'>
                      <LabelNota>{`Resultado de búsqueda: ${this.state.data_articulos.length} artículos.`}</LabelNota>
                    </div>
                  </Row> */}
                  <Row margen_arriba={10}>        
                    <div className='col-md-12'>
                      <div className='btn-group pull-right'>
                        <button type='submit' className='btn btn-primary btn-sm'><i className='fa fa-floppy-o fa-lg'></i> Guardar </button>
                        <button type='button' className='btn btn-default btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i> Limpiar </button>
                      </div>
                    </div>                  
                  </Row>  
                </form>
            </CuerpoForm>
          </ContenedorForm>
      );
  }
}

const mapStateToProps = ((state) => {
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            Usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit}
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormInven11);